// @ts-ignore
import metricsFormatTypes from '@/shared-reports/metrics-format.json';
import { FORMATS_MAP } from '@/views/formatters';
import type { FormatterArgs } from '@/services/types/formatter';

export default (args: FormatterArgs) => ({
  kind: 'reports-cost',
  tooltipText: args.ctx.t('To update the cost BeMob is synced with the source every 60 min'),
  inner: FORMATS_MAP[metricsFormatTypes[args.key]](args),
});
